import React, { Component } from "react";
import PropTypes from "prop-types";
import { history,authHeader } from "../../helpers";
import Paper from "@material-ui/core/Paper";
import format from 'date-fns/format';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import { Button, Checkbox, FormControlLabel } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import FormControl from '@material-ui/core/FormControl';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import BreadCrumbNav from "../BreadCrumbNav";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions,timeZoneToLocationMap } from '../../helpers';
import swal from 'sweetalert';
import api from '../../constants/api';
import { postApi } from '../../helpers/http';
import { store } from "../../helpers/store";
import ActionTypes from "../../constants/ActionTypes";

import "./Account.css";

const kRole = ["一般", "一般管理者", "管理者", "管理者"];
const kCanNewRole = [false, true, true, true];
const kCanDeleteAccount = [false, true, true, true];
function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />;
}


class Account extends Component {
   constructor(props) {
      super(props);
      this.state = {
         confirmDialog: false,
         selectedUser: {},
         offset: 0,
         limit: 100,
         date: null,
         tabValue: 0,
         data: [],
         i_num: -1,
         checkedDelete: false,
         openAlert: false,
         editSuccess: false,
         firstLoad: true, 
         order: "asc", 
         orderBy: "user_name",
         user_name: null,
         user_id : null,
         department_name: null,
         department_id : null,
         section_name: null,
         section_id : null,
      };
   }

   componentDidMount() {
      this.fetchData();
   }

   componentDidUpdate(prevProps) {
      if (
          !prevProps.requestAccountFail &&
          this.props.requestAccountFail
        ) {
         swal({
            title: "エラー！",
            text: this.props.items.user,
            icon: "warning",
            button: "はい",
         }).then(async () => {
            sessionStorage.clear();
            localStorage.clear();
            this.props.logout();
            window.location.replace("/index.html");
         });
        }
   }

   fetchData = () => {
      const { getAccounts } = this.props;
      const params = {
         user_id : this.state.user_id,
         user_name: this.state.user_name,
         section_id : this.state.section_id,
         section_name: this.state.section_name,
         department_name: this.state.department_name,
         date: format(Date.now(), 'yyyy-MM-dd')
      };
      getAccounts(params);
   }

   handleClickDownloadCSV = (filteredItems) => {
      const csvRows = ["検索条件："];  
      if (this.state.user_name === null) {
        csvRows.push("　アカウント名: すべて");
      } else if (this.state.user_name === "") {
        csvRows.push("　アカウント名: 空白");
      } else {
        csvRows.push("　アカウント名: " + this.state.user_name);
      };

      if (this.state.section_name === null) {
        csvRows.push("　部: すべて");
      } else if (this.state.section_name === "") {
        csvRows.push("　部: 空白");
      } else {
        csvRows.push("　部: " + this.state.section_name);
      };

      if (this.state.department_name === null) {
        csvRows.push("　課: すべて");
      } else if (this.state.department_name === "") {
        csvRows.push("　課: 空白");
      } else {
        csvRows.push("　課: " + this.state.department_name);
      };

      const csvHeaderTitles = ["アカウント名", "部", "課", "メール", "勤務地", "権限", "二段階認証"];
      csvRows.push([csvHeaderTitles.join(',')]);
      filteredItems.forEach(item => {
         const row = [
            item.user_name,
            item.section_name,
            item.department_name,
            item.login_email,
            timeZoneToLocationMap[item.time_zone] || '',
            kRole[item.role],
            item.enable2fa === 1 ? "オン" : "オフ",
         ];
         csvRows.push(row.join(','));
      });
      const csvData = csvRows.join('\n');
      const BOM = '\uFEFF'; // BOM for UTF-8
      const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });
      const date = new Date();
      const options = {
         timeZone: "Asia/Tokyo",
         year: 'numeric',
         month: '2-digit',
         day: '2-digit',
         hour: '2-digit',
         minute: '2-digit',
         hour12: false
      };
      const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
      const filename = `アカウント情報編集_${formattedDate}.csv`;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   }

   changePagination = (event, newPage) => {
      const newOffset = newPage - 1;
      this.setState({
        offset: newOffset
      });
    };
    
   render() {
      const user = getUser();
      const {items, isFetching,openAlert ,deleteSuccess, requestAccountFail} = this.props

      const filteredItems = items
         ? (
               stableSort(items.detailData || [], getComparator(this.state.order, this.state.orderBy))
            ).filter(
               (item) =>
                  {
                     return (
                        ( this.state.user_name === null ? true : this.state.user_name === "" ? item.user_name === "" 
                           : this.state.user_id !== null ? item.user_id === this.state.user_id
                           : item.user_name && item.user_name.includes(this.state.user_name)
                        ) &&
                        ( this.state.section_name === null ? true : this.state.section_name === "" ? item.section_name === "" 
                           : this.state.section_id !== null ? item.section_id === this.state.section_id
                           : item.section_name && item.section_name.includes(this.state.section_name)
                        ) &&
                        ( this.state.department_name === null ? true : this.state.department_name === "" ? item.department_name === "" 
                           : this.state.department_id !== null ? item.department_id === this.state.department_id
                           : item.department_name && item.department_name.includes(this.state.department_name)
                        ) 
                        // (this.state.user_id === null  || (this.state.user_id === item.user_id)) &&
                        // (this.state.user_name === null || (this.state.user_name === "") || (this.state.user_name !== "" && item.user_name.includes(this.state.user_name) ))&&
                        // (this.state.section_id === null || (this.state.section_id === item.section_id)) &&
                        // (this.state.section_name === null || (this.state.section_name === "" ) || (this.state.section_name !== "" && item.section_name.includes(this.state.section_name) )) &&
                        // (this.state.department_id === null || (this.state.department_id === item.department_id)) &&
                        // (this.state.department_name === null || (this.state.department_name === "") || (this.state.department_name !== "" && item.department_name.includes(this.state.department_name) ))
                        )
                     }
                  )
                  : [];
         
      // フィルターデータ設定
      let user_options , section_options ,department_options ;
      if (filteredItems.length >0){
         user_options=getFilterOptions(filteredItems,["user_id","user_name"],"user_name","user_name")
                  .sort((a, b) => a.user_name.localeCompare(b.user_name, undefined, {sensitivity: "base", numeric: true}));

         section_options=getFilterOptions(filteredItems,["section_id","section_name"],"section_name","section_name")
                  .sort((a, b) => a.section_name.localeCompare(b.section_name, undefined, {sensitivity: "base", numeric: true}));

         department_options=getFilterOptions(filteredItems,["department_id","department_name"],"department_name","department_name")
                  .sort((a, b) => a.department_name.localeCompare(b.department_name, undefined, {sensitivity: "base", numeric: true}));

      }

      const displayedItems = filteredItems.slice(this.state.offset * this.state.limit, (this.state.offset + 1) * this.state.limit);

      // 新規作成
      const handleClickNew = (event) => {
         history.push("index.html?p=account-new");
      };

      // OSマスタ・部署編集モードに変更
      const handleClickEdit = (userId, loginEmail) => {
         localStorage.setItem("email", loginEmail);
         // history.push(`/index.html?p=account-edit`); 
         history.push(`/index.html?p=account-edit&id=${userId}`); 
      };

      const handleClickOpenConfirmDialog = (event) => {
         const { value } = event.currentTarget;
         this.setState({
            selectedUser: JSON.parse(value),
            confirmDialog: true,
         });
      };

      const handleCloseConfirmDialog = () => {
         this.setState({
            selectedUser: {},
            confirmDialog: false,
            checkedDelete: false,
         });
      };

      const handleClickDelete = async () => {
         const { deleteAccount } = this.props;
         const params = {
            login_email: this.state.selectedUser.login_email, 
         };

         try {
            const json = await deleteAccount(params);
            if (json.statusCode === 200) {
               swal({
                  title: "削除しました。",  
                  icon: "success",
                  buttons: "はい"
               })
            } else {
               swal({
                  title: "設定エラー！",  
                  text: "削除に失敗しました。", 
                  icon: "warning",
                  button: "はい",
               });
            };
         } catch (error) {
            console.error('Error:', error);
            swal({
               title: "設定エラー！",  
               text: "サーバーエラーが発生しました。",  
               icon: "warning",
               button: "はい",  
            });
         };

         handleCloseConfirmDialog();
      };

      const handleCheckedDelete = (event) => {
         const checkedDelete = !this.state.checkedDelete;
         this.setState({ checkedDelete });
      };

      const handleCloseSuccess = () => {
         const { onCloseAlert } = this.props;
         onCloseAlert();
      };

      const createSortHandler = (property) => (event) => {
         const isAsc = this.state.orderBy === property && this.state.order === 'asc';
         const order = {order: isAsc ? 'desc' : 'asc'};
         this.setState(order);

         const orderBy = {orderBy: property};
         this.setState({
         ...order,
         ...orderBy,
         i_num: -1,
         firstLoad: false,
         });
         localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
      };

      const handleChangeFilter = (filterDict) => {
         const { changeFilterDatas } = this.props
         this.setState({ ...this.state,firstLoad: false,...filterDict});
         changeFilterDatas({...filterDict});
      };

      return (
         <div className="content-container">
            {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
               :<>
               <BreadCrumbNav screenName="アカウント情報編集"></BreadCrumbNav>
               <div className="loginname">ログイン名：{user.username}</div>
            
               <div className="filter-container">

                  <FormControl className="user-download">
                     <Button variant="contained" color="secondary" className="account__button-new"
                        onClick={handleClickNew} disabled={!kCanNewRole[user.role]}
                     >
                        アカウント登録
                     </Button>
                  </FormControl>

                  <FormControl className="formaccount-filter">
                     <Autocomplete
                        freeSolo
                        id="combo-box-autocomplete-user_name"
                        className="combo-box-autocomplete-account"
                        value={this.state.user_name}
                        // onChange={(event, newValue) => {
                        //    handleChangeFilter({user_id:newValue&&newValue.user_id?newValue.user_id:null,user_name: newValue&&newValue.user_name?newValue.user_name:"", firstLoad: false , offset: 0});
                        // }}
                        onChange={(event, newValue) => {
                           if (!newValue) {
                           handleChangeFilter({
                              user_name: null,
                              user_id: null,
                              firstLoad: false,
                              offset: 0
                           });
                           } else {
                           handleChangeFilter({
                              user_id: newValue.user_id ?? null,
                              user_name: newValue.user_name ?? "",
                              firstLoad: false,
                              offset: 0
                           });
                           }
                        }}
                        onInputChange={(event, value) => {
                           if (event && event.type === "change") {
                           handleChangeFilter({user_name:value,user_id:null,firstLoad: false , offset: 0 });
                           }
                        }}
                        options={
                           this.state.user_name && this.state.user_name.trim() !== "" && user_options
                           ? user_options.filter(item => item.user_name.toLowerCase().includes(this.state.user_name.toLowerCase()))
                           : user_options || []
                        }
                        getOptionLabel={(option) => 
                           typeof option === 'string' ? option : option?.user_name || ''
                        }
                        renderInput={(params) => (
                           <TextField
                           {...params}
                           className="autocomplete-filter"
                           label="アカウント名："
                           variant="outlined"
                           fullWidth
                           />
                        )}
                     />
                  </FormControl>

                  <FormControl className="formaccount-filter">
                     <Autocomplete
                        freeSolo
                        id="combo-box-autocomplete-section_name"
                        className="combo-box-autocomplete-account"
                        value={this.state.section_name}
                        // onChange={(event, newValue) => {
                        //    handleChangeFilter({section_id:newValue&&newValue.section_id?newValue.section_id:null,section_name: newValue&&newValue.section_name?newValue.section_name:"",firstLoad: false , offset: 0});
                        // }}
                        onChange={(event, newValue) => {
                           if (!newValue) {
                           handleChangeFilter({
                              section_name: null,
                              section_id: null,
                              firstLoad: false,
                              offset: 0
                           });
                           } else {
                           handleChangeFilter({
                              section_id: newValue.section_id ?? null,
                              section_name: newValue.section_name ?? "",
                              firstLoad: false,
                              offset: 0
                           });
                           }
                        }}
                        onInputChange={(event, value) => {
                           if (event && event.type === "change") {
                           handleChangeFilter({section_name:value,section_id:null,firstLoad: false , offset: 0});
                           }
                        }}
                        options={
                           this.state.section_name && this.state.section_name.trim() !== "" && section_options
                           ? section_options.filter(item => item.section_name.toLowerCase().includes(this.state.section_name.toLowerCase()))
                           : section_options || []
                        }
                        getOptionLabel={(option) => 
                           typeof option === 'string' ? option : option?.section_name || ''
                        }
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              className="autocomplete-filter"
                              label="部："
                              variant="outlined"
                              fullWidth
                           />
                        )}
                     />
                  </FormControl>

                  <FormControl className="formaccount-filter">
                     <Autocomplete
                        freeSolo
                        id="combo-box-autocomplete-department_name"
                        className="combo-box-autocomplete-account"
                        value={this.state.department_name}
                        // onChange={(event, newValue) => {
                        //    handleChangeFilter({department_id:newValue&&newValue.department_id?newValue.department_id:null,department_name: newValue&&newValue.department_name?newValue.department_name:"", firstLoad: false , offset: 0});
                        // }}
                        onChange={(event, newValue) => {
                           if (!newValue) {
                           handleChangeFilter({
                              department_name: null,
                              department_id: null,
                              firstLoad: false,
                              offset: 0
                           });
                           } else {
                           handleChangeFilter({
                              department_id: newValue.department_id ?? null,
                              department_name: newValue.department_name ?? "",
                              firstLoad: false,
                              offset: 0
                           });
                           }
                        }}
                        onInputChange={(event, value) => {
                           if (event && event.type === "change") {
                              handleChangeFilter({department_name:value,department_id:null,firstLoad: false , offset: 0 });
                           }
                        }}

                        options={
                           this.state.department_name && this.state.department_name.trim() !== "" && department_options
                              ? department_options.filter(item => item.department_name.toLowerCase().includes(this.state.department_name.toLowerCase()))
                              : department_options || []
                        }

                        getOptionLabel={(option) => 
                           typeof option === 'string' ? option : option?.department_name || ''
                        }
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              className="autocomplete-filter"
                              label="課："
                              variant="outlined"
                              fullWidth
                           />
                        )}
                     />
                  </FormControl>

                  <FormControl className="account-download">
                     <Button variant="contained" color="primary"
                        className="download-button"
                        onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                        disabled={!this.props.items || this.props.items.length === 0}
                     >
                        ダウンロード
                     </Button>
                  </FormControl>

                  <div className='account-item-count'>
                     <b> 検索結果：{filteredItems.length}件 </b>
                  </div>

               </div>

               <Paper className="table-root">
                  <TableContainer className="user-table-container">
                     <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                           <TableRow>
                              <TableCell  key="user_name" align="center" 
                                 sortDirection={this.state.orderBy === "user_name" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "user_name" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("user_name")}
                                 >
                                    アカウント名
                                    {this.state.orderBy === "user_name" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell 
                                 key="section_name" align="center" 
                                 sortDirection={this.state.orderBy === "section_name" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "section_name" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("section_name")}
                                 >
                                    部
                                    {this.state.orderBy === "section_name" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell 
                                 key="department_name" align="center" 
                                 sortDirection={this.state.orderBy === "department_name" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "department_name" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("department_name")}
                                 >
                                    課
                                    {this.state.orderBy === "department_name" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell key="login_email" align="center" 
                                 sortDirection={this.state.orderBy === "login_email" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "login_email" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("login_email")}
                                 >
                                    メール
                                    {this.state.orderBy === "login_email" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell key="time_zone" align="center" 
                                 sortDirection={this.state.orderBy === "time_zone" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "time_zone" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("time_zone")}
                                 >
                                    勤務地
                                    {this.state.orderBy === "time_zone" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell key="role" align="center" 
                                 sortDirection={this.state.orderBy === "role" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "role" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("role")}
                                 >
                                    権限
                                    {this.state.orderBy === "role" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell key="enable2fa" align="center" 
                                 sortDirection={this.state.orderBy === "enable2fa" ? this.state.order : false} style={{ minWidth: 120 }}
                              >              
                                 <TableSortLabel
                                    direction={this.state.orderBy === "enable2fa" ? this.state.order : 'asc'}
                                    onClick={createSortHandler("enable2fa")}
                                 >
                                    二段階認証
                                    {this.state.orderBy === "enable2fa" ? (
                                       <span className="visuallyHidden">
                                          {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                       </span>
                                    ) : null}
                                 </TableSortLabel>  
                              </TableCell>

                              <TableCell colSpan={2} align="center" style={{ maxWidth: 100 }}>
                                 操作
                              </TableCell>

                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {displayedItems.map((item, index) => (
                              <TableRow key={index} className={`${ item.active_flag !== 0 && "active-flag"}`}>
                                 <TableCell align="left" component="th" scope="row" > {item.user_name} </TableCell>
                                 <TableCell align="left" component="th" scope="row"> {item.section_name} </TableCell>
                                 <TableCell align="left" component="th" scope="row"> {item.department_name} </TableCell>
                                 <TableCell align="left" component="th" scope="row" > {item.login_email} </TableCell>
                                 <TableCell align="center" component="th" scope="row"> {item.time_zone ? timeZoneToLocationMap[item.time_zone] : ''} </TableCell>
                                 <TableCell align="center" component="th" scope="row"> {kRole[item.role]} </TableCell>
                                 <TableCell align="center" component="th" scope="row"> {item.enable2fa === 1 ? "オン" : "オフ"} </TableCell>
                                 <TableCell align="center" style={{ width: 100 }}>
                                    <Button variant="outlined" color="primary"  
                                       onClick={() => handleClickEdit(item.user_id, item.login_email)} disabled={user.role < item.role}
                                    >
                                       編集
                                    </Button>
                                 </TableCell>

                                 <TableCell align="center" style={{ width: 100 }} >
                                    <Button variant="outlined" color="primary" name={item.i_num}
                                       value={JSON.stringify({ i_num: item.i_num, user_name: item.user_name,
                                          department_name:
                                             item.department_name,
                                          login_email: item.login_email,
                                       })}
                                       onClick={ handleClickOpenConfirmDialog}
                                       disabled={!(kCanDeleteAccount[user.role] && user.role >= item.role)}
                                    >
                                       削除
                                    </Button>
                                 </TableCell>
                              </TableRow>
                           ))}
                        </TableBody>
                     </Table>
                  </TableContainer>

                  {filteredItems.length > 0 && 
                     <div className='pagination-button'>
                        <Pagination
                           page={this.state.offset + 1}
                           count={Math.ceil(filteredItems.length / this.state.limit)}
                           onChange={this.changePagination}
                           color="primary" variant="outlined" shape="rounded"
                           showFirstButton
                           showLastButton
                        />
                     </div>
                  }
               </Paper>
               
               </>
            }
            <Dialog
               open={this.state.confirmDialog}
               onClose={handleCloseConfirmDialog}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
            >
               <DialogTitle id="alert-dialog-title">{"削除確認"}</DialogTitle>
               <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                     {`ユーザー：${this.state.selectedUser.user_name}(${this.state.selectedUser.department_name})`}
                  </DialogContentText>
                  <div>
                     <FormControlLabel
                        control={
                           <Checkbox checked={this.state.checkedDelete}
                              onChange={handleCheckedDelete} name="checkedDelete"
                           />
                        }
                        label="この操作が取り消せないことを理解しています。"
                     />
                  </div>
               </DialogContent>
               <DialogActions>
                  <Button onClick={handleClickDelete} color="primary" disabled={!this.state.checkedDelete}>
                     削除
                  </Button>
               </DialogActions>
            </Dialog>
         </div>
      );
   }
}

Account.propTypes = {
   getAccounts: PropTypes.func.isRequired,
   deleteAccount: PropTypes.func.isRequired,
   changeFilterDatas: PropTypes.func.isRequired,
};

export default Account;
